"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
exports.isPolicyAllowsBsi = function (policyDetails) {
    return !policyDetails ||
        !policyDetails.policy ||
        (policyDetails.policy[types_1.ConsentPolicyCategories.Analytics] &&
            policyDetails.policy[types_1.ConsentPolicyCategories.Functional]);
};
//# sourceMappingURL=policy.js.map